import { useState } from 'preact/hooks';
import { useApi } from '../hooks/api';
import { flash, FlashMessage } from './flash-message';

export type NewCommentFormProps = {
    pullRequestNumber: number;
    onCommentPosted: () => void;
};

export const NewCommentForm = ({ pullRequestNumber, onCommentPosted }: NewCommentFormProps) => {
    const [commentText, setCommentText] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const api = useApi();

    const handleSubmit = async (e: Event) => {
        e.preventDefault();

        if (!commentText.trim() || !api) return;

        try {
            setIsSubmitting(true);
            await api.postIssueComment({
                issueNumber: pullRequestNumber,
                body: commentText,
            });

            setCommentText('');
            onCommentPosted();
        } catch (err) {
            flash(<FlashMessage type="error">Failed to post comment. Please try again.</FlashMessage>);
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleKeyDown = (e: KeyboardEvent) => {
        // Submit on Ctrl+Enter or Cmd+Enter (for Mac)
        if ((e.ctrlKey || e.metaKey) && e.key === 'Enter') {
            e.preventDefault();
            if (commentText.trim() && !isSubmitting && api) handleSubmit(new Event('submit'));
        }
    };

    return (
        <div className="card mt-4 mb-3">
            <div className="card-body">
                <h5 className="card-title">Add a comment</h5>
                <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                        <textarea
                            className="form-control"
                            value={commentText}
                            onChange={(e) => setCommentText(e.currentTarget.value)}
                            onKeyDown={handleKeyDown}
                            rows={4}
                            disabled={isSubmitting}
                        />
                    </div>
                    <button
                        type="submit"
                        className="btn btn-primary btn-sm"
                        disabled={!commentText.trim() || isSubmitting || !api}>
                        {isSubmitting ? 'Posting…' : 'Post comment'}
                    </button>
                </form>
            </div>
        </div>
    );
};
